<script>
import axios from "axios";
import {onMounted, ref} from "vue";
import useTools from "@/use/Tools";
import StrQuillEditorCorePdf from "@/components/StrQuillEditorCorePdf.vue";
import useSharedData from "@/use/SharedData";
import useSharedMethod from "@/use/SharedMethod";

export default {
    components: {StrQuillEditorCorePdf},
    setup() {
        const {dialog} = useSharedData();
        const {getBack} = useSharedMethod();
        const {$route} = useTools();

        const loading = ref(false);
        const previewOpen = ref(false);
        const html = ref("<h1 style='color: red'>Page Vide</h1>");

        function findById(id) {
            loading.value = true;
            axios.get(`/contrats/${id}`).then((response) => {
                html.value = response.data.templateText;
                previewOpen.value = true;
            }).finally(() => {
                loading.value = false;
            });
        }


        onMounted(() => findById($route.params.id));

        return {
            dialog,
            html,
            previewOpen,
            getBack,
        }
    }
};
</script>

<template>
    <v-dialog
        transition="dialog-bottom-transition"
        v-model="dialog"
        persistent
        max-width="900"
        scrollable
    >
        <v-card flat>
            <w-dialog-toolbar printAction/>
            <v-card-text>
                <str-quill-editor-core-pdf v-model="html"/>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <w-btn-close @press="getBack"/>
                <w-btn-print show/>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>